import { render, staticRenderFns } from "./BasePropTabContactSearchSettings.vue?vue&type=template&id=848dce22&scoped=true&"
import script from "./BasePropTabContactSearchSettings.vue?vue&type=script&lang=js&"
export * from "./BasePropTabContactSearchSettings.vue?vue&type=script&lang=js&"
import style0 from "./BasePropTabContactSearchSettings.vue?vue&type=style&index=0&id=848dce22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "848dce22",
  null
  
)

export default component.exports